import React from "react";
import {
  Box,
  TextField,
  TextFieldProps,
  CircularProgress,
} from "@mui/material";

type LoadingTextFieldProps = TextFieldProps & {
  loading: boolean;
};

const LoadingTextField: React.FC<LoadingTextFieldProps> = ({
  loading,
  ...props
}) => {
  return (
    <Box position="relative" width="100%">
      <TextField fullWidth {...props} disabled={loading || props.disabled} />
      {loading && (
        <Box
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          bgcolor="rgba(255, 255, 255, 0.6)"
          zIndex={1}
          borderRadius="4px"
        >
          <CircularProgress size={24} />
        </Box>
      )}
    </Box>
  );
};

export default LoadingTextField;
